import {
  AfterViewInit,
  Component,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
} from '@angular/material/expansion';
import { NavigationEnd, Router } from '@angular/router';

import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { MerchantBasicDataViewModel } from '@app/api/models';
import { UserService } from '@authentication/services/user.service';
import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import { MerchantSelectors } from '@merchant/store/merchant.slice';
import { MenuItem, sideNavItems } from '@shared/interfaces/sidenav';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren(MatExpansionPanel) matPanels!: QueryList<MatExpansionPanel>;
  @HostBinding('class.footer') @Input() footer: true | null = null;
  basicData!: MerchantBasicDataViewModel;
  roles: string[] = [];
  isRetailer = false;
  isRetailerProfile = false;
  retailerMenuItems: MenuItem[] = [];

  hasBasicData$ = this.store.select(MerchantSelectors.selectBasicData);
  userInfo$ = this.store.select(AuthenticationSelectors.selectUserInfo);
  isBasicDataLoading$ = this.store.select(MerchantSelectors.isBasicDataLoading);

  private subs = new SubSink();

  url = '';
  activeMenuUrl = '';
  selectedSegment = '';

  get menuItems(): MenuItem[] {
    const menu = [sideNavItems[1]]; // beszerzés
    if (!this.isRetailer) {
      if (this.isRetailerProfile) {
        menu.push(sideNavItems[2]); // értékesítés
      } else {
        menu.push(sideNavItems[3]); // értékesítés tenderrel
      }
    }
    return menu;
  }

  constructor(
    public authenticator: AuthenticatorService,
    private readonly userService: UserService,
    private readonly store: Store,
    public readonly router: Router
  ) {}

  ngOnInit() {
    this.subs.sink = this.userService.currentUserRoles.subscribe((roles) => {
      if (roles && JSON.stringify(roles) !== JSON.stringify(this.roles)) {
        this.roles = roles;
      }
    });

    this.subs.sink = this.hasBasicData$.subscribe((res) => {
      if (res) {
        this.basicData = res;
        this.isRetailer =
          !!this.basicData.highestMerchantType?.includes('RETAILER');
      }
    });

    this.subs.sink = this.userInfo$.subscribe((userInfo) => {
      this.isRetailerProfile =
        userInfo.attributes?.['custom:selectedMerchantType'].includes(
          'RETAILER'
        );
    });

    this.subs.sink = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.onResize();
    });
  }

  @HostListener('window:resize')
  onResize() {
    const buyingMenu = document.getElementById('buying');
    const buyingMenuWidth = buyingMenu?.getBoundingClientRect().width ?? 0;
    const buyingMenuTitleWidth =
      buyingMenu
        ?.getElementsByClassName('mat-expansion-panel-header')[0]
        .getBoundingClientRect().width ?? 0;

    buyingMenu!.style.marginRight = `${
      buyingMenuTitleWidth - buyingMenuWidth
    }px`;

    const sellingMenu = document.getElementById('selling');
    const sellingMenuWidth = sellingMenu?.getBoundingClientRect().width ?? 0;
    const sellingMenuTitleWidth =
      sellingMenu
        ?.getElementsByClassName('mat-expansion-panel-header')[0]
        .getBoundingClientRect().width ?? 0;

    if (sellingMenu) {
      sellingMenu.style.marginRight = `${
        sellingMenuTitleWidth - sellingMenuWidth
      }px`;
    }
  }

  @HostListener('document:click')
  clickout() {
    this.matPanels.toArray().forEach((panel) => panel.close());
  }

  onPanel(event: any, item: any, panelHeader: MatExpansionPanelHeader) {
    event.stopPropagation();
    if (item.level === 0) {
      this.matPanels.toArray().forEach((panel) => {
        if (panel.id !== panelHeader.panel.id) {
          panel.close();
        }
      });
    }
  }

  onMenuItem(event: any) {
    event.stopPropagation();
    this.matPanels.toArray().forEach((panel) => panel.close());
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
